import styled from '@emotion/styled';

export const Wrap = styled.div`
  border-bottom: 3px solid #444052;
  display: flex;
  flex-flow: row nowrap;
  padding: 0 8px;
  margin-bottom: 16px;

  input,
  label {
    line-height: 44px;
  }

  label {
    font-size: 14px;
    font-weight: 500;
    padding: 0 16px 0 0;
    user-select: none;
    transition: color 0.4s ease-out;
  }

  input,
  textarea {
    font-size: 16px;
    font-weight: 600;
    background-color: transparent;
    outline: 0;
    border: 0;
    color: var(--white);
    padding: 0;
    flex: 1;
  }

  &.input-textarea {
    flex-flow: column wrap;
  }

  &.input-focused {
    border-bottom-color: var(--purple-branding);

    label {
      color: #a19fa9;
    }
  }

  &.input-has-value label {
    color: #a19fa9;
  }
`;
